import { defaultFont } from '../../style.js'

const checkBoxStyle = {
  root: {
    paddingTop: '10px'
  },
  disabled: {
    '&:before': {
      backgroundColor: 'transparent !important',
      color: '#333 !important'
    }
  },
  labelRoot: {
    ...defaultFont,
    color: '#333 !important',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '2',
    letterSpacing: 'unset',
    marginTop: '0px !important'
  }
}

export default checkBoxStyle
